import { render } from "./ResponseUnit.vue?vue&type=template&id=52da152e&scoped=true"
import script from "./ResponseUnit.vue?vue&type=script&lang=js"
export * from "./ResponseUnit.vue?vue&type=script&lang=js"

import "./ResponseUnit.vue?vue&type=style&index=0&id=52da152e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52da152e"]])

export default __exports__